import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
export const MealCalorieIcon = ({ classObject }) => {
    return React.createElement("img", { className: css(styles.icon, classObject), src: "/assets/images/icons/meal_calorie.svg", alt: "" });
};
// Figma 4120:290684 内のカロリーアイコンは18×18px。
const styles = StyleSheet.create({
    icon: {
        width: 18,
        height: 18,
    },
});
